import { useSetAtom } from 'jotai';
import {
  cofCommentsState,
  openState,
  pofCommentsState,
  selectedField,
  titleState,
  transitionCommentsState,
} from '../state/atoms';

const useDialogState = () => {
  const setOpen = useSetAtom(openState);
  const setSelectedField = useSetAtom(selectedField);
  const setTitle = useSetAtom(titleState);
  const setPofCommentsState = useSetAtom(pofCommentsState);
  const setCofCommentsState = useSetAtom(cofCommentsState);
  const setTransitionCommentsState = useSetAtom(transitionCommentsState);

  const handleOpenDialog = (isOpen: boolean, key: string, title: string) => {
    setOpen(isOpen);
    setSelectedField(key);
    setTitle(title);
  };

  const resetDialogState = () => {
    setOpen(false);
    setSelectedField('');
    setTitle('');
  };

  const resetCommentState = () => {
    setPofCommentsState((previous) => {
      if (!previous) {
        return previous;
      }
      return {
        ...previous,
        comments: previous.comments.map((comment) => ({ ...comment, text: '' })),
      };
    });
    setCofCommentsState((previous) => {
      if (!previous) {
        return previous;
      }
      return {
        ...previous,
        comments: previous.comments.map((comment) => ({ ...comment, text: '' })),
      };
    });
    setTransitionCommentsState((previous) => {
      if (!previous) {
        return previous;
      }
      return {
        ...previous,
        comments: previous.comments.map((comment) => ({ ...comment, text: '' })),
      };
    });
  };
  return { handleOpenDialog, resetCommentState, resetDialogState };
};

export default useDialogState;
